import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="pageContainer">
      <h1>Terms of Service</h1>
      <p>
        <strong>Effective Date:</strong> May 21, 2025
      </p>

      <p>
        Welcome to easyzilla! These Terms of Service (“Terms”) govern your use
        of our website and services. By signing up or using our platform, you
        agree to these Terms. If you do not agree, please do not use the
        service.
      </p>

      <h2>1. Use of the Service</h2>
      <p>
        You may use our web app to create and publish webpages, as long as you
        comply with these Terms and all applicable laws.
      </p>

      <h2>2. Account Registration</h2>
      <p>
        To use certain features, you must create an account. You agree to
        provide accurate and complete information and to keep your login
        credentials secure. You are responsible for all activity under your
        account.
      </p>

      <h2>3. User Content</h2>
      <p>
        You retain ownership of the content you create and publish. By using our
        platform, you grant us a limited license to host and display your
        content solely for providing the service.
      </p>
      <p>
        You agree not to post any content that is unlawful, harmful, abusive,
        hateful, threatening, obscene, or otherwise objectionable. We reserve
        the right to remove content that violates these Terms or our policies.
      </p>

      <h2>4. Prohibited Uses</h2>
      <ul>
        <li>Using the service for illegal activities</li>
        <li>Attempting to hack, overload, or disrupt the platform</li>
        <li>Copying or reverse-engineering our code or services</li>
        <li>Violating intellectual property rights</li>
      </ul>

      <h2>5. Termination</h2>
      <p>
        We may suspend or terminate your account if you violate these Terms or
        misuse the platform. You may delete your account at any time via your
        account settings.
      </p>

      <h2>6. Disclaimer of Warranties</h2>
      <p>
        Our service is provided “as is” without warranties of any kind. We do
        not guarantee that the service will be error-free, secure, or
        uninterrupted.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        To the maximum extent allowed by law, we are not liable for any
        indirect, incidental, or consequential damages arising out of your use
        of the service.
      </p>

      <h2>8. Modifications to the Service</h2>
      <p>
        We may update or discontinue features of the platform at any time
        without prior notice.
      </p>

      <h2>9. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. If changes are significant,
        we will notify you via the app or by email. Continued use after changes
        means you accept the new terms.
      </p>

      <h2>10. Contact Us</h2>
      <p>If you have any questions about these Terms, you can contact us at:</p>
      <p>
        <strong>Email:</strong>{" "}
        <a href="mailto:hello@easyzilla.com">hello@easyzilla.com</a>
      </p>
      <br />
      <p>
        <Link to="/">Back to home</Link>
      </p>
    </div>
  );
}
